import { ControllerUpdated } from '@/business-logic/profile'
import { Approval, ApprovalApi } from '@/shared/apis/approvals'

export enum DBNotifications {
  PROFILE_UPDATED = 'profile-updated',
  PROFILE_UPDATE_ERROR = 'profile-update-error',
  PROFILE_IMPORTED = 'profile-imported',
  NOTIFICATION = 'notification',
}

export const BGNotifications = {
  NEW_ACTIVITY: 'new-activity',
  KEYCHAIN_LOCKED: 'keychain-locked',
  ControllerUpdated: 'ControllerUpdated',
  RemoteProviderConnectionExpirationEvent:
    'RemoteProviderConnectionExpirationEvent',
  ApprovalCancelEvent: 'ApprovalCancelEvent',
  RemoteProviderConnectionClosedEvent: 'RemoteProviderConnectionClosedEvent',
  RemoteProviderConnectionEstablishedEvent:
    'RemoteProviderConnectionEstablishedEvent',
} as const

export const AppNotifications = { ...DBNotifications, ...BGNotifications }
export type AppNotifications = typeof AppNotifications

export interface RemoteProviderConnectionEvent<T extends string> {
  id: string
  type: T
}

export type RemoteProviderConnectionEstablishedEvent =
  RemoteProviderConnectionEvent<'RemoteProviderConnectionEstablishedEvent'>

export type RemoteProviderConnectionExpirationEvent =
  RemoteProviderConnectionEvent<'RemoteProviderConnectionExpirationEvent'>

export type RemoteProviderConnectionClosedEvent =
  RemoteProviderConnectionEvent<'RemoteProviderConnectionClosedEvent'>

export type RemoteProviderEventConnectionType =
  | RemoteProviderConnectionEstablishedEvent
  | RemoteProviderConnectionExpirationEvent
  | RemoteProviderConnectionClosedEvent

export type BGNotificationAPI = {
  [BGNotifications.NEW_ACTIVITY]: {
    payload: Approval<keyof ApprovalApi, unknown>
  }
  [BGNotifications.KEYCHAIN_LOCKED]: {
    payload: undefined
  }
  [BGNotifications.ControllerUpdated]: {
    payload: ControllerUpdated
  }
  [BGNotifications.RemoteProviderConnectionExpirationEvent]: {
    payload: RemoteProviderConnectionExpirationEvent
  }
  [BGNotifications.ApprovalCancelEvent]: {
    payload: Approval<keyof ApprovalApi, unknown>
  }
  [BGNotifications.RemoteProviderConnectionClosedEvent]: {
    payload: RemoteProviderConnectionClosedEvent
  }
  [BGNotifications.RemoteProviderConnectionEstablishedEvent]: {
    payload: RemoteProviderConnectionEstablishedEvent
  }
}

export type BGNotificationAPIParams<T extends keyof BGNotificationAPI> = {
  method: T
  payload: BGNotificationAPI[T]['payload']
}
